import React from "react";
import { Dimensions, Platform, ScrollView, StyleSheet, View } from "react-native";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, ImageSizeTokens, SizeTypeTokens, StepperTypeTokens, TextAlignTokens } from "@voltmoney/schema";
import { SCREEN_SIZE } from '@voltmoney/types';
import { Header } from "../../header/Header";
import { Button } from "../../button/Button";
import { Typography } from "../../typography/Typography";
import { Space } from "../../space/Space";
import { Image } from "../../image/Image";
const PhotoMismatchPage = ({ height, stepperData, retryAllowed = true, goToPhotoAction, goToSupportDocAction, triggerAction, goBackAction, isFromJupiter }) => {
    const stepperProps = {
        data: stepperData,
        type: StepperTypeTokens.HORIZONTAL,
        onPress: null,
    };
    const handleGoToPhoto = () => {
        goToPhotoAction &&
            triggerAction(goToPhotoAction);
    };
    const handleGoToSupportDoc = () => {
        goToSupportDocAction &&
            triggerAction(goToSupportDocAction);
    };
    const _headerChild = () => {
        return (React.createElement(View, { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between'
            } },
            React.createElement(Header, { type: HeaderTypeTokens.verification, stepperProps: stepperProps, isBackButton: true, onPress: async () => await triggerAction(goBackAction), title: 'Photo verification', isFromJupiter: isFromJupiter })));
    };
    const _bodyChild = () => {
        return (React.createElement(React.Fragment, null, React.createElement(ScrollView, { style: {
                height: '100%',
                paddingTop: 16,
                paddingHorizontal: 16,
            } },
            React.createElement(View, { style: {
                    paddingTop: 72,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                } },
                React.createElement(Image, { size: ImageSizeTokens.Size_40, uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/system_Error1.png', width: 64, height: 64 }),
                React.createElement(Space, { size: SizeTypeTokens.XXXL }),
                React.createElement(Typography, { label: 'The captured photo does not match the Aadhaar photo', fontFamily: FontFamilyTokens.Poppins, fontWeight: '600', fontSize: FontSizeTokens.MD, textAlign: TextAlignTokens.center, lineHeight: 24 }),
                React.createElement(Space, { size: SizeTypeTokens.XL }),
                React.createElement(View, { style: {
                        padding: 12,
                        backgroundColor: '#FFF6DD'
                    } },
                    React.createElement(Typography, { label: 'Please make sure that you capture the photo in a well-lit area and avoid wearing glasses or a cap.', fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.SM, textAlign: TextAlignTokens.center, lineHeight: 20 })),
                React.createElement(Space, { size: SizeTypeTokens.XL })))));
    };
    const _footerChild = () => {
        return (React.createElement(View, { style: {
                width: '100%',
                padding: 16
            } }, retryAllowed ?
            React.createElement(React.Fragment, null,
                React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, label: 'Capture photo again', width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, onPress: () => handleGoToPhoto() })) :
            React.createElement(React.Fragment, null,
                React.createElement(View, null,
                    React.createElement(Typography, { label: 'Is the photo on your Aadhaar unclear?', fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.SM, textAlign: TextAlignTokens.center, lineHeight: 20, color: ColorTokens.Grey_Charcoal }),
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, label: 'Try another way to verify', width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, onPress: () => handleGoToSupportDoc() }),
                    React.createElement(Space, { size: SizeTypeTokens.LG }),
                    React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, label: 'Capture photo again', width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, onPress: () => handleGoToPhoto() })))));
    };
    return (React.createElement(View, { style: [
            styles.container,
            { height: Platform.OS === "ios" ? height - 24 : height }
        ] },
        React.createElement(View, { style: {
                flex: 1
            } },
            React.createElement(View, { style: styles.header }, _headerChild()),
            React.createElement(View, { style: [styles.body, { height: height - 192 }] }, _bodyChild()),
            React.createElement(View, { style: styles.footer }, _footerChild()))));
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
const styles = StyleSheet.create({
    container: {
        width: '100%',
    },
    header: {},
    body: {},
    footer: {
        position: 'absolute',
        bottom: 0,
        zIndex: 99,
        width: '100%',
    },
    groupContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    transactionCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
    },
    transactionTopCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        paddingBottom: 2,
    },
    transactionBottomCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: "space-between"
    }
});
export default (PhotoMismatchPage);
